import React from 'react'
import { graphql, PageProps, navigate } from 'gatsby'
import SEO from '../components/SEO'
import * as style from '../styles/templates/post.module.scss'
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";
deckDeckGoHighlightElement();

type PostProps = {
	markdownRemark: {
		html: string
		frontmatter: {
			date: string
			title: string
			tags: string[]
			image: string | undefined
		}
	}
}

const Post = ({ data: { markdownRemark } }: PageProps<PostProps> ) => {
	const tagRedirect = (category: string, event: any) => {
		const slug = category.replace(/\s/g, '-').toLowerCase()
		event.preventDefault()
		navigate(`/tag/${slug}`)
	}

	return (
		<>
			<SEO title={markdownRemark.frontmatter.title}  />
			<p className={style.date}>{markdownRemark.frontmatter.date}</p>
			<h1>{markdownRemark.frontmatter.title}</h1>
			<div className={style.tags}>
				{markdownRemark.frontmatter.tags.map(( category, index ) => (
					<button onClick={(event) => tagRedirect(category, event)} key={index} role="link">{category}</button>
				))}
			</div>
			<div className={style.content} dangerouslySetInnerHTML={{ __html: markdownRemark.html}}></div>
		</>
	)
}

export default Post

export const query = graphql`
	query($slug: String!) {
		markdownRemark(fields: { slug: { eq: $slug } }) {
            html
            frontmatter {
				date(formatString: "Do [of] MMMM, YYYY")
                title
				tags
            }
        }
	}
`